import { render, staticRenderFns } from "./live.vue?vue&type=template&id=9575e0aa&scoped=true&"
import script from "./live.vue?vue&type=script&lang=js&"
export * from "./live.vue?vue&type=script&lang=js&"
import style0 from "./live.vue?vue&type=style&index=0&id=9575e0aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9575e0aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9575e0aa')) {
      api.createRecord('9575e0aa', component.options)
    } else {
      api.reload('9575e0aa', component.options)
    }
    module.hot.accept("./live.vue?vue&type=template&id=9575e0aa&scoped=true&", function () {
      api.rerender('9575e0aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/live.vue"
export default component.exports